import React from "react";
import * as S from "../styles";

type PasswordNotCreatedMessageProps = {
  email: string;
};

export default function PasswordNotCreatedMessage({
  email,
}: PasswordNotCreatedMessageProps): React.ReactElement {
  return (
    <>
      <S.MessageTitle>Senha ainda não criada</S.MessageTitle>
      <S.MessageText>
        Identificamos que você ainda não criou sua senha de acesso. Enviamos um
        e-mail para <strong>{email}</strong> com o link para a criação da nova
        senha.
      </S.MessageText>
    </>
  );
}
